import {
    coreExtensionData,
    createFrontendModule,
} from "@backstage/frontend-plugin-api";
import scaffolderPlugin from "@backstage/plugin-scaffolder/alpha";

import { ExperimentalGuard } from "../experimentalTemplatePage/ExperimentalGuard";
import { LifecycleFilterGuard } from "../lifecycleFilterPage/LifecycleFilterGuard";
import { TemplateEntityProvider } from "../templateEntity";
import { DeprecationGuard } from "./DeprecationGuard";

const templatePageOverride = scaffolderPlugin
    .getExtension("sub-page:scaffolder/templates")
    .override({
        factory(originalFactory) {
            const originalOutput = originalFactory();
            const originalElement = originalOutput.get(
                coreExtensionData.reactElement
            );
            const outputWithoutElement = [...originalOutput].filter(
                data => data.id !== coreExtensionData.reactElement.id
            );
            return [
                ...outputWithoutElement,
                coreExtensionData.reactElement(
                    <LifecycleFilterGuard>
                        <TemplateEntityProvider>
                            <DeprecationGuard>
                                <ExperimentalGuard>
                                    {originalElement}
                                </ExperimentalGuard>
                            </DeprecationGuard>
                        </TemplateEntityProvider>
                    </LifecycleFilterGuard>
                ),
            ];
        },
    });

export const scaffolderModuleDeprecatedTemplatePage = createFrontendModule({
    pluginId: "scaffolder",
    extensions: [templatePageOverride],
});
